import { FieldProps } from 'formik';
import React from 'react';
import TextField from '@material-ui/core/TextField';

interface IOwnProps {
    afterOnChange?: (value: string) => void;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

type TProps = FieldProps & IOwnProps;

const FieldWrapper = ({
    field,
    form,
    afterOnChange,
    onChange,
    ...props
}: TProps) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        form.setFieldValue(field.name, value);
        if (afterOnChange) {
            afterOnChange(value);
        }
    };

    return (
        <TextField
            margin="dense"
            fullWidth={false}
            {...field}
            {...props}
            onChange={onChange || handleChange}
            InputLabelProps={{
                style: {
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '100%',
                },
            }}
        />
    );
};

export default FieldWrapper;
